
import React from "react";
import Select from "react-select";

export type Option = {
  value: string;
  label: string;
};

export interface SelectProps {
  options: Option[];
  value?: Option | string  | null; // Controlled by parent
  className?: string;
  styles?: any;
  onChange?: (option: Option | null) => void;
  placeholder:string
}

const CommonSelectTwo: React.FC<SelectProps> = ({ options, value, className, onChange , placeholder}) => {
 
   const normalizedValue =
  typeof value === "string"
    ? options.find((option) => option.value === value || option.label === value) 
      || (value ? { value, label: value } : null)  // fallback when no options
    : value || null;

  return (
    <Select
      classNamePrefix="react-select"
      className={className}
      options={options}
      value={normalizedValue} // value is controlled externally
      onChange={onChange}
      placeholder={placeholder}
    />
  );
};

export default CommonSelectTwo;
